import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import CookiePopup from "./components/CookiePopup";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./components/Home/Home";
import About from "./components/About/About";
import ScheduleaDemo from "./components/Scheduleademo/ScheduleaDemo";
import WorkforceScheduler from "./components/WorkforceScheduler/Workforce";
import CapacityPlanning from "./components/CapacityPlanning/Capacity";
import TimeAttendance from "./components/TimeandAttendance/TimeAttendance";
import OperationalWorkloadPlanning from "./components/OperationalWorkloadPlanning/Operational";
import AutomatedWorkAllocation from "./components/AutomatedWorkAllocation/Automated";
import EmployeeSelfService from "./components/EmployeeSelfService/Employee";
import ConnectedSystem from "./components/ConnectedSystem/Connected";
import MetaHelmet from "./components/MetaHelmet";
import NotFound from "./components/NotFound";

import "./index.css";

const COOKIE_KEY = "jivisolutions_user_data";

function App() {
  const [cookiesAccepted, setCookiesAccepted] = useState(false);
  const [checkedCookie, setCheckedCookie] = useState(false);

  useEffect(() => {
    const status = Cookies.get(COOKIE_KEY);
    if (status === "accepted" || status === "declined") {
      setCookiesAccepted(true);
    }
    setCheckedCookie(true);
  }, []);

  useEffect(() => {
    if (!checkedCookie) return;
    document.body.style.overflow = cookiesAccepted ? "" : "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, [cookiesAccepted, checkedCookie]);

  const handleAccept = () => {
    Cookies.set(COOKIE_KEY, "accepted", {
      expires: 30,
      sameSite: "Lax",
      secure: window.location.protocol === "https:",
      path: "/",
    });
    setCookiesAccepted(true);
  };

  const handleDecline = () => {
    Cookies.set(COOKIE_KEY, "declined", {
      expires: 30,
      sameSite: "Lax",
      secure: window.location.protocol === "https:",
      path: "/",
    });
    setCookiesAccepted(true);
  };

  if (!checkedCookie) return null;

  return (
    <div className="font-epilogue">
      <Router>
        <ScrollToTop />
        <MetaHelmet />

       
        <div className="fixed top-0 left-0 w-full z-[9999] bg-white shadow">
          <Header />
        </div>
        <div className="pt-[60px] md:pt-[70px]" />

      
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/schedule-a-demo" element={<ScheduleaDemo />} />
          <Route path="/workforce-scheduler" element={<WorkforceScheduler />} />
          <Route path="/capacity-planning" element={<CapacityPlanning />} />
          <Route path="/time-attendance" element={<TimeAttendance />} />
          <Route path="/connected-systems" element={<ConnectedSystem />} />
          <Route
            path="/operational-workload-planning"
            element={<OperationalWorkloadPlanning />}
          />
          <Route
            path="/automated-work-allocation-assignment"
            element={<AutomatedWorkAllocation />}
          />
          <Route
            path="/employee-self-service"
            element={<EmployeeSelfService />}
          />

         
          <Route path="*" element={<NotFound />} />
        </Routes>

        <Footer />

        {!cookiesAccepted && (
          <CookiePopup
            onAccept={handleAccept}
            onDecline={handleDecline}
          />
        )}
      </Router>
    </div>
  );
}

export default App;
